'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExpandableText = require('./components/ExpandableText.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExpandableText).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/expandable/lib/components/expandable-text/index.js
// module id = 1413
// module chunks = 1